var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07227 11.2515C8.00347 11.2515 8.80499 11.3813 9.49219 11.6011C7.92109 12.8143 7.07227 14.5571 7.07227 16.2515C7.07233 16.7252 7.16683 17.1465 7.34277 17.5015H2.07227C2.07227 17.5015 0.822578 17.501 0.822266 16.2515C0.822266 15.0015 2.07227 11.2515 7.07227 11.2515ZM14.5723 11.2515C19.5719 11.2517 20.8223 15.0015 20.8223 16.2515C20.822 17.4883 19.5972 17.5013 19.5723 17.5015H9.57227C9.57227 17.5015 8.32258 17.501 8.32227 16.2515C8.32227 15.0015 9.57227 11.2515 14.5723 11.2515ZM6.44727 3.75146C8.17298 3.75167 9.57227 5.1507 9.57227 6.87646C9.57201 8.60201 8.17282 10.0013 6.44727 10.0015C4.72153 10.0015 3.32252 8.60214 3.32227 6.87646C3.32227 5.15057 4.72138 3.75146 6.44727 3.75146ZM14.5723 2.50146C16.6432 2.50167 18.3223 4.18053 18.3223 6.25146C18.322 8.32219 16.643 10.0013 14.5723 10.0015C12.5014 10.0015 10.8225 8.32232 10.8223 6.25146C10.8223 4.1804 12.5012 2.50146 14.5723 2.50146Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.51d69432f9cf54867154014c2287ce59.svg";
export { ForwardRef as ReactComponent };